export default {
  Title: 'QR Codes | QR Code | QR Codes',

  Toolbar: {
    Button: {
      New: {
        Title: 'Νέο QR Code',
        Icon : 'add_box',
        Color: 'primary'
      },
      Settings: {
        Title: 'QR Codes Design',
        Icon : 'qr_code_2',
        Color: 'primary'
      },
      Export: {
        Title         : 'Export',
        Icon          : 'file_download',
        Color         : 'primary',
        SuccessMessage: 'You will soon receive a record of the export of QR Codes in the email: {email}'
      }
    }
  },

  Table: {
    Headers: {
      Id       : '#',
      Code     : 'Code',
      Data     : 'Data',
      Type     : 'Type',
      CreatedAt: 'Date',
      Actions  : ''
    }
  },

  Type: {
    table  : {Id: '6', Enum: 'table', Name: 'Table', Type: 'TBL', Title: 'Table'},
    room   : {Id: '8', Enum: 'room', Name: 'Room', Type: 'HRM', Title: 'Room'},
    sunbed : {Id: '9', Enum: 'sunbed', Name: 'Sunbed', Type: 'SNB', Title: 'Sunbed'},
    booth  : {Id: '7', Enum: 'booth', Name: 'Booth', Type: 'BTH', Title: 'Booth'},
    catalog: {Id: '0', Enum: 'catalog', Name: 'Catalog', Type: 'CAT', Title: 'Catalog'},
    home   : {Id: '0', Enum: 'home', Name: 'Home', Type: 'HOM', Title: 'Home'},
    mobile : {Id: '0', Enum: 'mobile', Name: 'Mobile', Type: 'MOB', Title: 'Mobile'}
  },

  Dialog: {
    Delete: {
      Title       : 'Delete QR Code?',
      Content     : 'Are you sure you want to delete the QR Code?',
      Notification: '@:Restaurant.Menu.Dialog.Delete.Notification'
    }
  },

  SettingsDialog: {
    Toolbar: {
      Title   : 'QR Codes Design',
      Subtitle: 'QR Codes Design',
      Icon    : 'qr_code',
      Color   : 'indigo'
    }
  },

  AddEditDialog: {
    Toolbar: {
      Add: {
        Title   : 'Add QR Code',
        Subtitle: 'Create a New QR Code'
      },
      Edit: {
        Title   : 'Edit QR Code',
        Subtitle: 'Modify QR Code Details'
      },
      Icon : 'qr_code',
      Color: 'indigo'
    },

    Field: {
      Data: {
        Label: 'Data',
        Hint : 'Data. eg. TABLE INSIDE #3, etc.',
        Icon : 'http',
        Error: {
          Between: 'The data must be between 2 and 100 characters'
        }
      },
      Type: {
        Label: 'Type',
        Hint : 'Type QR Code. eg. Table',
        Icon : 'checklist',
        Error: {
          Required: 'Select type of QR Code'
        }
      }
    }
  }
}
